<!--
Author: TangChen
Date: 2018-09-17
Desc: 我的资产组件，由index.js 配置引入
-->
<template>
    <div>
        <div :class="'bizcomp-my-plan bizcomp ' + className">
            <div class="my-plan-head">
                <el-tabs v-model="activeName" v-on:tab-click="handleClick">
                    <el-tab-pane name="1">
                        <el-badge slot="label" class="investment-1">普通定投</el-badge>
                    </el-tab-pane>
                    <!-- <el-tab-pane name="7">
                        <el-badge slot="label" class="investment-7">目标盈定投</el-badge>
                    </el-tab-pane>
                    <el-tab-pane name="4">
                        <el-badge slot="label" class="investment-2">智能定投</el-badge>
                    </el-tab-pane> -->
                    <!-- <el-tab-pane name="3">
                        <el-badge slot="label" class="investment-3">组合定投</el-badge>
                    </el-tab-pane> -->
                </el-tabs>
                <!--<div class="cal-content pointer" v-on:click="$router.push('/planCalculator')">-->
                <!--<img src="../../assets/img/cal-log.png" alt="" class="cal-log" />-->
                <!--定投计算器&gt;&gt;-->
                <!--</div>-->
            </div>

            <div v-if="!addC" class="main-content-div">
                <div v-for="(item, index) of pageFund" :key="index" class="main-content">
                    <div class="left-content">
                        <div class="fund-name-code">
                            <span class="fund-name">{{ item.fundshortname || item.fundname }}</span>
                            <span class="fund-code">{{ item.fundcode }}</span>
                            <span
                                :class="
                                    'fund-status ' +
                                    (item.status == 'N'
                                        ? 'normal-color'
                                        : item.status == 'P'
                                        ? 'stop-color'
                                        : 'termination-color')
                                "
                            >
                                {{ formatterStatus(item.status) }}
                            </span>
                        </div>
                        <div class="fund-info">
                            <div class="margin-100 width-100">
                                <div class="color-666">
                                    {{ activeName == "2" ? "基础金额" : "扣款金额" }}
                                </div>
                                <div>
                                    {{ formatterNum(item.firstinvestamount) }}
                                </div>
                            </div>
                            <div class="margin-100 width-150">
                                <div class="color-666">扣款账户</div>
                                <div>
                                    {{
                                        $cache.getDict("110080", item.bankcode).substr(-4, 4) +
                                        "(" +
                                        item.depositcard.substr(-4, 4) +
                                        ")"
                                    }}
                                </div>
                            </div>
                            <div class="margin-100 width-150">
                                <div class="color-666">扣款时间</div>
                                <div>{{ formatterCycle(item) }}</div>
                            </div>
                            <div>
                                <div class="color-666">预计下次扣款时间</div>
                                <div>{{ $util.fmtDate(item.nextinvestdate) }}</div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <button class="desc-btn" v-on:click="showDetail(item.planno)">详情</button>
                    </div>
                </div>
                <div
                    v-if="!$util.belongHx()"
                    class="add-plan-content"
                    v-on:click="activeName === '3' ? (addC = true) : $router.push('/gfund/glist')"
                >
                    <div class="add-plan-btn">
                        <div class="add-icon">+</div>
                        <div class="color-E60012 add-text">新增定投协议</div>
                    </div>
                </div>
                <el-pagination
                    v-if="allPage - 0 >= Number(pageSize)"
                    :current-page.sync="curPage"
                    :page-size="Number(pageSize)"
                    layout="total, prev, pager, next"
                    :total="allPage"
                    class="pagination-content"
                    v-on:current-change="handleCurrentChange"
                ></el-pagination>
            </div>
            <!--组合定投start-->
            <combofund v-if="activeName === '3' && addC"></combofund>
            <!--组合定投end-->
        </div>

        <footerQuestions :common-question="commonQuestion"></footerQuestions>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import fundApi from "@/api/fund";
import footerQuestions from "@/components/layout/footerQuestions.vue";
import combofund from "@/bizcomponents/comboBuy/combofund.vue";

export default {
    name: "MyPlanDc",
    components: { footerQuestions, combofund },
    mixins: [mixin],
    data() {
        return {
            activeName: "1",
            curPage: 1,
            allPage: 0,
            pageSize: this.$util.getConfig().const.PAGE_SIZE
                ? this.$util.getConfig().const.PAGE_SIZE
                : 10,
            gfund: [],
            detailFund: [],
            pageFund: [],
            commonQuestion: [
                {
                    title: "详细了解智能定投？",
                    answer: "智能定投是传统“定期定额投资”方式的改良，又称“定期不定额投资”，智能定投可根据证券市场的走势以不固定金额进行投资，实现对投资时点的自动判断和对投资金额的灵活控制，力争使定投收益最大化。<br>具体地说，智能定投是指在每月固定的日期(T日)，根据T-1日某证券市场指数与该指数均线的比较情况，在T日自动增加或减少基金定投金额。在证券市场指数低于该指数均线时，增加每月扣款金额；高于该指数均线时，减少每月扣款金额。即在基金净值较低时，增加投资金额，获得更多份额；在基金净值较高时，减少投资金额，从而进一步降低申购成本，使得成本平摊效果更好。",
                    showFlag: false
                },
                {
                    title: "如果约定扣款日正好遇到节假日，还会扣款吗？",
                    answer: "扣款日遇到非工作日的，将自动顺延到下一工作日扣款。",
                    showFlag: false
                },
                {
                    title: "已设置的定投计划，连续几次扣款不成功协会怎么样？",
                    answer: "连续三次扣款失败，协议会自动终止。",
                    showFlag: false
                },
                {
                    title: "已办理的定投业务，是否可以增加扣款金额？",
                    answer: "可以，请您登录“网上交易”，点击智能定投栏目，并通过修改操作进行修改定投协议。可以修改您的扣款日期，扣款频率及扣款金额。",
                    showFlag: false
                },
                {
                    title: "定投协议取消后基金份额还在吗？",
                    answer: "终止定投协议不等于基金赎回。取消定投协议后将不会再进行定投扣款，但已经定投申购的基金份额仍保留在基金账户中，您可以根据需要继续持有或选择合适时机赎回、转换。",
                    showFlag: false
                },
                {
                    title: "普通基金定投可以改成智能定投吗？怎么改？",
                    answer: "除大成标普500等权重指数基金以及大成纳斯达克指数基金外，您在我司网站上设置的基金定投均可以修改成智能定投。只需登录进入您的网上交易账户，点击左侧“我的定投计划”，找到原来协议后，点击“修改”，选择“定期不定额”，即可改为智能定投并设置相关参数。",
                    showFlag: false
                }
            ],
            addC: false
        };
    },
    created() {
        this.getPlanList();
        if (this.$route.query && this.$route.query.planType) {
            this.activeName = this.$route.query.planType;
        }
    },
    methods: {
        showDetail(id) {
            const fund = this.detailFund.filter((item) => {
                return item.planno === id;
            })[0];
            if (fund) {
                const _x = Object.assign({}, fund);
                sessionStorage.setItem("plandetail", JSON.stringify(_x));
                this.$router.push({
                    name: "plandetail",
                    query: { fundcode: _x.fundcode, planType: this.activeName }
                });
            }
        },
        handleClick(tab, event) {
            this.addC = false;
            this.detailFund = [];
            this.gfund.forEach((item) => {
                if (item.planflag == this.activeName) {
                    this.detailFund.push(item);
                }
            });
            this.curPage = 1;
            this.handleCurrentChange();
        },
        formatterCycle(row) {
            if (!row.investcycle || !row.investcyclevalue) {
                return "";
            }
            const cyclestr =
                (row.investcycle == "2" ? "每" : "") +
                this.$cache.getDict("110009", row.investcycle); // 0-月，1-周，2-双周，3-每日
            let valuestr;
            if (row.investcycle == "0") {
                valuestr = row.investcyclevalue + "日";
            } else if (row.investcycle == "3") {
                valuestr = "";
            } else {
                valuestr = "星期" + row.investcyclevalue;
            }
            return cyclestr + (this.$util.isEmpty(valuestr) ? "" : valuestr);
        },
        formatterStatus(value) {
            if (value == "N") {
                return "正常";
            } else if (value == "P") {
                return "暂停";
            } else {
                return "终止";
            }
        },
        formatterNum(value) {
            if (value.indexOf(",") > -1) {
                const _x = value.split(",");
                let _z = "";
                // 定转显示
                for (let i in _x) {
                    _z += this.$util.fmtNum(_x[i]) + "</br>";
                }
                return _z;
            }
            return this.$util.fmtNum(value);
        },
        handleCurrentChange() {
            this.allPage = this.detailFund.length;
            let i = 0;
            this.pageFund = [];
            for (i; i < this.pageSize; i++) {
                if (this.detailFund[(this.curPage - 1) * this.pageSize + i]) {
                    this.pageFund.push(this.detailFund[(this.curPage - 1) * this.pageSize + i]);
                } else {
                    return;
                }
            }
        },
        // 获取资产信息
        async getPlanList() {
            const res = await fundApi.getPlan();
            if (res.data) {
                this.gfund = res.data.data || [];
                this.gfund = this.planArrGroup(this.gfund);
                this.detailFund = this.gfund;
                this.handleClick();
            }
        },
        // 对定投协议进行排序，列表第一排列顺序为状态，参与中>已暂停>已终止；列表第二排列顺序为定投成功期数，以期数最多倒序排列；
        planArrGroup(planArr) {
            const successFund = [];
            const stopFund = [];
            const terminationFund = [];
            planArr.forEach((item) => {
                if (item.status == "N") {
                    successFund.push(item);
                } else if (item.status == "P") {
                    stopFund.push(item);
                } else {
                    terminationFund.push(item);
                }
            });
            return [
                ...this.planArrSort(successFund),
                ...this.planArrSort(stopFund),
                ...this.planArrSort(terminationFund)
            ];
        },
        planArrSort(planArr) {
            if (planArr.length == 0) {
                return [];
            }
            const planObject = {};
            planArr.forEach((item) => {
                let key = item.investcycle + "-" + item.investcyclevalue;
                if (!planObject[key]) {
                    // 如果该key不存在于结果对象中，则初始化一个新的数组
                    planObject[key] = [];
                    // 将当前项添加到对应的数组中
                    planObject[key].push(item);
                } else {
                    planObject[key].push(item);
                }
            });
            const planArrSort = [];
            Object.values(planObject).forEach((item) => {
                planArrSort.push(item);
            });
            planArrSort.sort((a, b) => b.length - a.length);
            return [].concat(...planArrSort);
        }
    }
};
</script>
<style lang="scss" scoped>
.bizcomp-my-plan {
    .my-plan-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: 1px solid #f1f1f1;
        font-weight: normal;
        .investment-1:hover {
            color: #e60012;
        }
        .investment-2:hover {
            color: #e60012;
        }
        .investment-3:hover {
            color: #e60012;
        }
        .investment-7:hover {
            color: #e60012;
        }
        .cal-content {
            margin-right: 20px;
            height: 40px;
            line-height: 40px;
            font-size: 16px;
            color: #ff7d00;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 150px;
            border-radius: 20px;
            background: linear-gradient(180deg, #fffcf6 0%, #fffbf3 100%);
            box-sizing: border-box;
            border: 1px solid linear-gradient(180deg, #ffefdf 0%, #ffebda 100%);
            .cal-log {
                margin-right: 4.6px;
            }
        }
    }
    :deep(.el-tabs__header) {
        margin: 0;
    }
    :deep(.el-tabs__nav-wrap::after) {
        height: 0 !important;
    }
    :deep(.el-tabs__item) {
        padding: 0;
        width: 130px;
        text-align: center;
        height: 70px;
        line-height: 70px;
        font-family: "Source Han Sans CN";
        font-size: 20px;
        color: #666;
    }
    :deep(.is-active) {
        color: #e60012;
        font-weight: 500;
    }
    :deep(.el-tabs__active-bar) {
        width: 80px !important;
        height: 4px;
        margin-left: 25px;
        background: #e60012;
        position: absolute;
        top: 59px;
    }
    .main-content-div {
        padding: 20px;
        .add-plan-content {
            padding: 16px 0;
            border-bottom: 1px solid #f1f1f1;
            cursor: pointer;
            .add-plan-btn {
                width: 248px;
                height: 50px;
                border-radius: 30px;
                background: #f9f9f9;
                margin: 0 auto;
                display: flex;
                justify-content: center;
                align-items: center;
                .add-icon {
                    padding: 4px 8px;
                    background: #e60012;
                    border: none;
                    border-radius: 50%;
                    color: #ffffff;
                    margin-right: 6px;
                }
            }
            .add-plan-btn:hover {
                color: #ffffff;
                background-color: #e60012;
                .add-icon {
                    border: 1px solid #ffffff;
                }
                .add-text {
                    color: #ffffff;
                    background-color: #e60012;
                }
            }
        }
    }
    .main-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        border-bottom: 1px solid #f1f1f1;
        .left-content {
            padding: 20px 0 19px;
            .fund-name-code {
                padding-bottom: 14px;
                .fund-name {
                    font-size: 16px;
                    font-weight: bold;
                    line-height: 20px;
                    margin-right: 10px;
                }
                .fund-code {
                    font-size: 14px;
                    font-weight: 500;
                    margin-right: 10px;
                    color: #999999;
                }
                .fund-status {
                    padding: 3px 10px;
                    font-size: 12px;
                    font-weight: 500;
                    text-align: center;
                    border-radius: 15px;
                }
            }
            .fund-info {
                display: flex;
            }
        }
    }
    .el-pagination {
        margin: 19px 0 0;
    }
    .desc-btn {
        width: 107px;
        height: 40px;
        border-radius: 2px;
        color: #e60012;
        background: #ffffff;
        box-sizing: border-box;
        border: 1px solid #d9d9d9;
        cursor: pointer;
    }
    .desc-btn:hover {
        color: #ffffff;
        background: #e60012;
    }
    .pagination-content {
        text-align: end;
    }
    .color-666 {
        color: #666666;
    }
    .color-E60012 {
        color: #e60012;
    }
    .normal-color {
        color: #0256ff;
        background: #e8ecff;
    }
    .stop-color {
        color: #f0a10e;
        background: #ffeece;
    }
    .termination-color {
        color: #ea0000;
        background: #ffdede;
    }
    .margin-100 {
        margin-right: 100px;
    }
    .width-100 {
        width: 100px;
    }
    .width-150 {
        width: 150px;
    }
}
</style>
